import { Stack, Typography } from '@mui/material';

import { Select, SelectProps } from './Select';

const countries = [
  { code: 'US', name: 'USA' },
  { code: 'CA', name: 'Canada' },
  { code: 'AU', name: 'Australia' },
  { code: 'GB', name: 'UK' },
  { code: 'JP', name: 'Japan' },
  { code: 'IN', name: 'India' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'CN', name: 'China' },
];

export interface CountrySelectProps<T extends string | number>
  extends Omit<SelectProps<T>, 'options' | 'getOptionLabel'> {}

export const CountrySelect = (props: CountrySelectProps<string>) => {
  const countryCodes = countries.map((country) => country.code);

  const getCountryName = (countryCode: string) => {
    const country = countries.find((country) => country.code === countryCode);
    return country ? country.name : '';
  };

  return (
    <Select
      {...props}
      options={countryCodes}
      getOptionLabel={(countryCode) => (
        <Stack spacing={2} direction="row" alignItems="center">
          <img
            src={`https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`}
            alt={countryCode}
            style={{ width: 28 }}
          />
          <Typography variant="body2" component="span">
            {getCountryName(countryCode)}
          </Typography>
        </Stack>
      )}
      placeholder={props.placeholder || 'Select a country'}
    />
  );
};
